var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export const getDocument = (fileId, ws) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield new Promise(resolve => {
        ws.send('request:/clauselink-document-view:post', { routeId: fileId }, (data) => resolve(data));
    });
    if (response.statusCode !== 200) {
        throw Error('Failed to fetch document data');
    }
    return response.payload;
});
